'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxForm = require('redux-form');



var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');

var _messageModal = require('../../../redux/modules/messageModal');



var _propertyDetails = require('../../../redux/modules/propertyDetails');




var _checkRtlLanguage = require('../../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _MessageFromCompanyComponent = require('./MessageFromCompanyComponent');var _MessageFromCompanyComponent2 = _interopRequireDefault(_MessageFromCompanyComponent);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var initializeForm = function initializeForm(values) {return (0, _reduxForm.initialize)('MessagesForm', values);};

var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    messages: state.propertyDetails.messages,
    messageSubmitting: state.propertyDetails.messageSubmitting,
    projectDetails: state.propertyDetails.data,
    userToken: state.userAuthentication.data ? state.userAuthentication.data.access_token : null,
    userId: state.userAuthentication.data ? state.userAuthentication.data.id : null,
    isOwner: (0, _get2.default)(state.propertyDetails, 'data.owner_id') === (0, _get2.default)(state.userAuthentication, 'data.id') };};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  upsertMessage: _propertyDetails.upsertMessageAction,
  deleteMessage: _propertyDetails.deleteMessageAction,
  initializeForm: initializeForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal }),

(0, _reduxForm.reduxForm)({
  form: 'MessagesForm' }))(_MessageFromCompanyComponent2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/MessageFromCompany.js
// module id = 2825
// module chunks = 0